import styled from 'styled-components';
import { Box } from '../Box/Box';
import { Flex } from '../Flex/Flex';
const SlideWrapper = /*#__PURE__*/styled(Box).withConfig({
  displayName: "SlideBoxstyled__SlideWrapper",
  componentId: "sc-1vvl5qd-0"
})([""]);
const ScrollFlex = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "SlideBoxstyled__ScrollFlex",
  componentId: "sc-1vvl5qd-1"
})(["position:relative;overflow:auto;scroll-behavior:smooth;& > ", "{flex-shrink:0;}"], SlideWrapper);
export { ScrollFlex, SlideWrapper };